var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Group_5",
    width: 25,
    height: 37.634,
    "data-name": "Group 5",
    viewBox: "0 0 25 37.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5_Copy",
    "data-name": "Group 5 Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    fill: "#072b4f",
    d: "M12.5 0A12.5 12.5 0 0 1 25 12.5c0 5.912-9.167 20.635-11.8 24.75a.833.833 0 0 1-1.4 0C9.167 33.137 0 18.412 0 12.5A12.5 12.5 0 0 1 12.5 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDoc);
export default __webpack_public_path__ + "static/media/pin-doc.8250214557192ffb3fb96c16361ec5a2.svg";
export { ForwardRef as ReactComponent };